import { useContext, useState } from 'react';
import { ContentContext } from '../../contexts/ContentContext';
import useContent from '../../hooks/useContent';
import useUnsavedChanges from '../../hooks/useUnsavedChanges';
import AdminTopbar from '../AdminTopbar';
import SaveBar from '../components/SaveBar';
import ConfirmModal from '../components/ConfirmModal';

export default function FooterEditor() {
  const { content, updateSection } = useContext(ContentContext);
  const { draft, isDirty, saving, lastSaved, update, save, discard } =
    useContent(content.footer);
  useUnsavedChanges(isDirty);

  const [deleteIdx, setDeleteIdx] = useState(null);

  const handleSave    = () => save(patch => updateSection('footer', patch));
  const handleDiscard = () => discard(content.footer);

  const links = draft.links || [];

  const updateLink = (i, patch) =>
    update({ links: links.map((l, idx) => idx === i ? { ...l, ...patch } : l) });

  const addLink = () =>
    update({ links: [...links, { label: 'New Link', href: '/' }] });

  return (
    <div className="adm-page">
      <AdminTopbar title="Footer" />
      <SaveBar isDirty={isDirty} saving={saving} lastSaved={lastSaved}
               onSave={handleSave} onDiscard={handleDiscard} />

      {deleteIdx !== null && (
        <ConfirmModal
          message="Delete this footer link?"
          onConfirm={() => { update({ links: links.filter((_, i) => i !== deleteIdx) }); setDeleteIdx(null); }}
          onCancel={() => setDeleteIdx(null)}
        />
      )}

      <div className="adm-editor">
        <section className="adm-section">
          <h3 className="adm-section__title">Tagline</h3>
          <div className="adm-field">
            <label className="adm-label">Footer Tagline</label>
            <input className="adm-input" value={draft.tagline || ''}
              onChange={e => update({ tagline: e.target.value })} />
          </div>
        </section>

        <section className="adm-section">
          <h3 className="adm-section__title">Footer Links</h3>
          <div className="adm-list">
            {links.map((link, i) => (
              <div key={i} className="adm-list__row">
                <input className="adm-input adm-input--sm" placeholder="Label"
                  value={link.label} onChange={e => updateLink(i, { label: e.target.value })} />
                <input className="adm-input adm-input--sm" placeholder="/path"
                  value={link.href} onChange={e => updateLink(i, { href: e.target.value })} />
                <button className="adm-btn adm-btn--danger adm-btn--sm"
                  onClick={() => setDeleteIdx(i)}>✕</button>
              </div>
            ))}
          </div>
          <button className="adm-btn adm-btn--ghost" onClick={addLink}>+ Add Link</button>
        </section>

        <section className="adm-section">
          <h3 className="adm-section__title">Legal</h3>
          <div className="adm-field">
            <label className="adm-label">Copyright Text</label>
            <input className="adm-input" placeholder="© 2025 Klaivox. All rights reserved."
              value={draft.copyright || ''}
              onChange={e => update({ copyright: e.target.value })} />
          </div>
          <div className="adm-field">
            <label className="adm-label">Privacy Policy URL</label>
            <input className="adm-input" placeholder="/privacy"
              value={draft.privacyUrl || ''}
              onChange={e => update({ privacyUrl: e.target.value })} />
          </div>
          <div className="adm-field">
            <label className="adm-label">Terms URL</label>
            <input className="adm-input" placeholder="/terms"
              value={draft.termsUrl || ''}
              onChange={e => update({ termsUrl: e.target.value })} />
          </div>
        </section>
      </div>
    </div>
  );
}
